module.exports = __webpack_public_path__ + "static/img/4.5454225.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/21/eng/4.png
// module id = 2vOw
// module chunks = 0